//trims a given text to the specified number of characters
//(@para1 = string, @para2 desired character length)
const truncate = (string: string, n: number): string => {
  return string?.length > n ? string.substr(0, n - 1) + '...' : string;
};

export default truncate;
